import React, { lazy, Suspense, useEffect, useState } from "react";
import { Switch, Redirect, useLocation } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH, LoggedInState } from "configs/AppConfig";
import { server } from "configs/ApiConfig";
import SecureRoute from "./SecureRoute";
import AuthService from "services/AuthService";
// if (server === "production") {
//   console.log = () => {};
//   console.error = () => {};
//   console.debug = () => {};
// }

console.log("under testing value ....");

export const AppViews = () => {
  const [servicesList, setServicesList] = useState();
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);

  const location = useLocation();
  // const history = useHistory()

  useEffect(() => {
    setPermissionsLoaded(false);
    AuthService.permissionsHandler().then((res) => {
      const readServices = res?.map((role) => {
        return role.Access.map((item) => {
          return item.Read === true && item.Service;
        }).filter((e) => e);
      });

      const writeServices = res?.map((role) => {
        return role.Access.map((item) => {
          return item.Write === true && item.Service;
        }).filter((e) => e);
      });

      var readServicesList;

      if (readServices?.length === 1) {
        readServicesList = readServices[0];
      } else if (readServices?.length === 2) {
        readServicesList = [...readServices[0], ...readServices[1]];
      } else if (readServices?.length === 3) {
        readServicesList = [
          ...readServices[0],
          ...readServices[1],
          ...readServices[2],
        ];
      }

      setServicesList(readServicesList);

      var writeServicesList;

      if (writeServices?.length === 1) {
        writeServicesList = writeServices[0];
      } else if (writeServices?.length === 2) {
        writeServicesList = [...writeServices[0], ...writeServices[1]];
      } else if (writeServices?.length === 3) {
        writeServicesList = [
          ...writeServices[0],
          ...writeServices[1],
          ...writeServices[2],
        ];
      }

      localStorage.setItem("ReadServices", JSON.stringify(readServicesList));
      localStorage.setItem("WriteServices", JSON.stringify(writeServicesList));

      setPermissionsLoaded(true);
    });
  }, [location.key]);

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>

        <SecureRoute
          path={`${APP_PREFIX_PATH}/userengagementdashboard`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") || servicesList?.includes("userengagementdashboard")
                ? lazy(() => import(`./userengagementdashboard`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./userengagementdashboard`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          path={`${APP_PREFIX_PATH}/vouchers`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("vouchers")
                ? lazy(() => import(`./vouchers`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./vouchers`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/games`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") || servicesList?.includes("games")
                ? lazy(() => import(`./games`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./games`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/tniForm`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("tniForm")
                ? lazy(() => import(`./tniForm`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./tniForm`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/annualtrainingcalendar`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("annualtrainingcalendar")
                ? lazy(() => import(`./annualtrainingcalendar`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./annualtrainingcalendar`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/tniForm`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("tniForm")
                ? lazy(() => import(`./tniForm`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./tniForm`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/annualtrainingcalendar`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("annualtrainingcalendar")
                ? lazy(() => import(`./annualtrainingcalendar`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./annualtrainingcalendar`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(() => import(`./elearning`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./elearning`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/incentive`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("incentive")
                ? lazy(() => import(`./incentive`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./incentive`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/incentive/incentiveWeekList`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("incentive")
                ? lazy(() => import(`./incentive/incentiveWeekList`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./incentive/incentiveWeekList`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/incentive/newincentive`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("incentive")
                ? lazy(() => import(`./incentive/createIncentive`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./incentive/createIncentive`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/incentive/processed`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("incentive")
                ? lazy(() => import(`./incentive/approve`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./incentive/approve`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance/allfiles`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance/allfiles/AllFiles`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance/allfiles/AllFiles`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance/upload`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance/allfiles`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance/allfiles`))
          }
          auth={LoggedInState}
        />

        {/*  Start Contest Ui and Mession Ui Url Config */}

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance/contest`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance/contests`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance/contests`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance/newcontest`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance/createcontest`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance/createcontest`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance/mission/details`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance/mission`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance/mission`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/performance/upload/mission`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./performance/mission/UploadMission`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./performance/mission/UploadMission`))
          }
          auth={LoggedInState}
        />

        {/*  End Contest Ui and Mession Ui Url Config */}

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/starperformers`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("starperformers")
                ? lazy(() => import(`./starperformers`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./starperformers`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/starperformer/creditnewcoin`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("starperformers")
                ? lazy(() => import(`./starperformers/AddStarPerformers`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./starperformers/AddStarPerformers`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/creditcoins`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("creditcoins")
                ? lazy(() => import(`./creditcoins`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./creditcoins`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/creditcoins/addcreditcoin`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("creditcoins")
                ? lazy(() => import(`./creditcoins/CreditCoin`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./creditcoins/CreditCoin`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/surveys`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("surveys")
                ? lazy(() => import(`./surveys`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./surveys`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          path={`${APP_PREFIX_PATH}/survey/upload`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("surveys")
                ? lazy(() => import(`./surveys/survey/UploadSurvey`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./surveys/survey/UploadSurvey`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          path={`${APP_PREFIX_PATH}/announcements`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("announcements")
                ? lazy(() => import(`./announcements`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./announcements`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/events`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("events")
                ? lazy(() => import(`./events`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./events`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/employees`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("employees")
                ? lazy(() => import(`./employees`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./employees`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/employees/edit/:employeeid`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("employees")
                ? lazy(
                    () =>
                      import(
                        `./employees/employeesTable/singleEdit/SingleEdit`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(`./employees/employeesTable/singleEdit/SingleEdit`),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          path={`${APP_PREFIX_PATH}/employees/settings/Settings`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("employees")
                ? lazy(() => import(`./employees/settings/Settings`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./employees/settings/Settings`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/addlearnergroup`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/learnergroups/addLearnerGroup`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/learnergroups/addLearnerGroup`
                    ),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/editlearnergroup`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/learnergroups/learnerDetail`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/learnergroups/learnerDetail`
                    ),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/editlearnergroup/editCourse`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/learnergroups/learnerDetail/GetCourseEdit`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/learnergroups/learnerDetail/GetCourseEdit`
                    ),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          path={`${APP_PREFIX_PATH}/elearning/assignlearners`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/learnergroups/assignLearners/AssignLearners`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/learnergroups/assignLearners/AssignLearners`
                    ),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          path={`${APP_PREFIX_PATH}/elearning/detail`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () => import(`./elearning/components/courses/courseDetail`),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () => import(`./elearning/components/courses/courseDetail`),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/elearning/assignusers`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/learnergroups/assignLearners/AssignUsersForNomination`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/learnergroups/assignLearners/AssignUsersForNomination`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/addcourses`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(() => import(`./elearning/components/courses/addCourse`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./elearning/components/courses/addCourse`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/editcourses`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () => import(`./elearning/components/courses/editCourse`),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./elearning/components/courses/editCourse`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/livevideo`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/addCourse/addModule/liveatream`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/addCourse/addModule/liveatream`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/addcourses/video`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/addCourse/addModule/video`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/addCourse/addModule/video`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/addcourses/classroom`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/addCourse/addModule/classroom`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/addCourse/addModule/classroom`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/addcourses/document`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/addCourse/addModule/document`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/addCourse/addModule/document`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/addcourses/quiz`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/addCourse/addModule/quiz`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/addCourse/addModule/quiz`
                    ),
                )
          }
          auth={LoggedInState}
        />
        {/* course detail */}
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/video`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/video`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(`./elearning/components/courses/courseDetail/video`),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/document`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/document`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/courseDetail/document`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/quiz`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/quiz`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(`./elearning/components/courses/courseDetail/quiz`),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/scorm`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/scorm`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(`./elearning/components/courses/courseDetail/scorm`),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/classroom`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/classroom`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/courseDetail/classroom`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/learningPath`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/learnergroups/LearnerGroups`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/learnergroups/LearnerGroups`
                    ),
                )
          }
          auth={LoggedInState}
        />
        {/* end course detail */}
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/permissions`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("permissions")
                ? lazy(() => import(`./permissions`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./permissions`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/taskbox`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("taskbox")
                ? lazy(() => import(`./taskbox`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./taskbox`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/coinhistory`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("coinhistory")
                ? lazy(() => import(`./coinhistory`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./coinhistory`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/spotreward`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("spotreward")
                ? lazy(() => import(`./spotreward`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./spotreward`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/reward/:id`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("spotreward")
                ? lazy(() => import(`./spotreward/DetailReward`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./spotreward/DetailReward`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/distribution`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("spotreward")
                ? lazy(() => import(`./spotreward/DistributionReward`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./spotreward/DistributionReward`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/attendance`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("attendance")
                ? lazy(() => import(`./attendance`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./attendance`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/checklists`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("checklists")
                ? lazy(() => import(`./checklists`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./checklists`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/checklists/addchecklist`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("checklists")
                ? lazy(() => import(`./checklists/components/addChecklist`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./checklists/components/addChecklist`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/checklists/:id`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("checklists")
                ? lazy(
                    () =>
                      import(
                        `./checklists/components/reports/components/Checklist`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./checklists/components/reports/components/Checklist`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/checklists/responses/:id`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("checklists")
                ? lazy(
                    () =>
                      import(
                        `./checklists/components/reports/components/Responses`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./checklists/components/reports/components/Responses`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/checklists/notcompleted/:id`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("checklists")
                ? lazy(
                    () =>
                      import(
                        `./checklists/components/reports/components/NotCompleted`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./checklists/components/reports/components/NotCompleted`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/leave`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") || servicesList?.includes("leave")
                ? lazy(() => import(`./leave`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./leave`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/settings`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("settings")
                ? lazy(() => import(`./settings`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./settings`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/holidays`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("holidays")
                ? lazy(() => import(`./holidays`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./holidays`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/holidays/assign`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("holidays")
                ? lazy(() => import(`./holidays/assignHoliday`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./holidays/assignHoliday`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/assetrequest`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("assetrequest")
                ? lazy(() => import(`./assetrequest`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./assetrequest`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/assetapprove`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("assetapprove")
                ? lazy(() => import(`./assetapprove`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./assetapprove`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/assetmanager`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("assetmanager")
                ? lazy(() => import(`./assetmanager`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./assetmanager`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/servicedesk`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./servicedesk`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./servicedesk`))
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/servicedesk/settings/Category/Category`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(
                    () =>
                      import(
                        `./servicedesk/components/settings/Category/Category`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./servicedesk/components/settings/Category/Category`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/servicedesk/settings/SubCategory/SubCategory`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(
                    () =>
                      import(
                        `./servicedesk/components/settings/SubCategory/SubCategory`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./servicedesk/components/settings/SubCategory/SubCategory`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/podcast`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./podcast/index`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./podcast/index`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/podcast/add-podcast`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./podcast/addPodcast/index`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./podcast/addPodcast/index`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/podcast/upload`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./podcast/addPodcast/audioUploda`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./podcast/addPodcast/audioUploda`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/podcast`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./podcast/index`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./podcast/index`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/podcast/add-podcast`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./podcast/addPodcast/index`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./podcast/addPodcast/index`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/podcast/upload`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("servicedesk")
                ? lazy(() => import(`./podcast/addPodcast/audioUploda`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./podcast/addPodcast/audioUploda`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/lmscopilot`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("lmscopilot")
                ? lazy(() => import(`./lmscopilot`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./lmscopilot`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/qrreports`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("qrreports")
                ? lazy(() => import(`./qr-report`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./qr-report`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/incentive/createincentivegroup`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("performance")
                ? lazy(() => import(`./incentive/createincentivegroup`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./incentive/createincentivegroup`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/feedback`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/feedback`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/courseDetail/feedback`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          path={`${APP_PREFIX_PATH}/survey/quiz`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("surveys")
                ? lazy(() => import(`./surveys/survey/quiz`))
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(() => import(`./surveys/survey/quiz`))
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/survey`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/survey`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/courseDetail/survey`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/checklists/trends/store/response`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("checklists")
                ? lazy(
                    () =>
                      import(
                        `./checklists/components/reports/tabscomponents/components/Monthwisetrends.js`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./checklists/components/reports/tabscomponents/components/Monthwisetrends.js`
                    ),
                )
          }
          auth={LoggedInState}
        />

        <SecureRoute
          exact
          path={`${APP_PREFIX_PATH}/elearning/activity`}
          component={
            permissionsLoaded
              ? servicesList?.includes("all") ||
                servicesList?.includes("elearning")
                ? lazy(
                    () =>
                      import(
                        `./elearning/components/courses/courseDetail/activity`
                      ),
                  )
                : lazy(() => import(`../auth-views/errors/error-page-2`))
              : lazy(
                  () =>
                    import(
                      `./elearning/components/courses/courseDetail/activity`
                    ),
                )
          }
          auth={LoggedInState}
        />
        <Redirect
          exact
          from={`${APP_PREFIX_PATH}`}
          to={`${APP_PREFIX_PATH}/${
            servicesList
              ? servicesList[0] === "all"
                ? "vouchers"
                : servicesList[0]
              : "vouchers"
          }`}
          auth={LoggedInState}
        />
        <SecureRoute
          path="*"
          component={lazy(() => import(`../auth-views/errors/error-page-1`))}
          auth={LoggedInState}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
